import React, { useState, useEffect } from 'react';

export default function SubsectionTitle({ settings, stepNumber, injectAbove = false, cartAttributes }) {
	const [stepsTitles, setStepsTitles] = useState([]);
	const [subsectionTitle, setSubsectionTitle] = useState([]);

	useEffect(() => {
		if (settings.stepsTitles) {
			setStepsTitles(settings.stepsTitles.split(','));
		}

		if (settings.subsectionTitles) {
			setSubsectionTitle(settings.subsectionTitles.split(',')[stepNumber - 1]);
		}
	}, [settings]);

	useEffect(() => {
		if (
			injectAbove &&
			cartAttributes &&
			Object.keys(cartAttributes).length > 0 &&
			cartAttributes?.deliveryMethod !== 'digitalProductsOnly'
		) {
			//move this component  after .cart-header element
			const steps = document.querySelector('.subsection-title');
			
			if (steps) {
				steps.remove();
				document.querySelector('.cart-header').after(steps);
			}
		}
	}, [injectAbove, cartAttributes]);

	if (!settings) return null;

	if (cartAttributes.deliveryMethod == 'digitalProductsOnly') {
		return null;
	}

	return (
		<div className="subsection-title">
			<div className="subsection-title__header">
				<h2 className="h2" id={`step-${stepNumber}`}>
					{' '}
					{stepNumber == 3 && cartAttributes.deliveryMethod == 'delivery'
						? settings.buttonDeliveryLabel
						: subsectionTitle}
				</h2>
				{settings.buttonContinueShoppingText && settings.buttonContinueShoppingLink && (
					<a
						className="subsection-title__button button button--lg button--underlined animated-underline animated-text"
						href={settings.buttonContinueShoppingLink}
					>
						<text-animation data-hover={settings.buttonContinueShoppingText}>
							{settings.buttonContinueShoppingText}
						</text-animation>
					</a>
				)}
			</div>

			<div className="subsection-title__steps">
				{stepsTitles.map((title, index) => (
					<a
						key={index}
						href={`#step-${index + 1}`}
						className={`subsection-title__step ${
							stepNumber === index + 1 ? 'subsection-title__step--active' : ''
						}`}
					>
						<span className="subsection-title__step-number">{index + 1}</span>
						<span className="subsection-title__step-title">
							{index === 2 && cartAttributes.deliveryMethod === 'delivery'
								? settings.buttonDeliveryLabel
								: title}
						</span>
					</a>
				))}
			</div>
		</div>
	);
}
